// extracted by mini-css-extract-plugin
module.exports = {"periodSelectView":"index_periodSelectView_PI1Re","welfare-badge":"index_welfare-badge_3rqrP","rate-content":"index_rate-content_RxJMb"};